export default {
  title: 'Wolt Drive -käyttöönotto',
  subtitle: 'Näkyy vain käyttöönottopäälliköille.',
  steps: {
    request: {
      title: '1. Pyydä ravintolaa Woltilta',
      description:
        'Kopioi tämän ravintolan rivin jaettuun Wolt-taulukkoon. Liitä se seuraavan tyhjän rivin sarakkeeseen A ja ilmoita siitä Woltille yhteisessä Slack-kanavassa.',
    },
    activate: {
      title: '2. Vahvista ja aktivoi',
      description:
        'Syötä taulukkoon lisätty Wolt-ravintolatunnus. Se tarkistetaan Woltin testitarjouksella ennen tallentamista.',
    },
  },
  fields: {
    venue_id: {
      label: 'Wolt-ravintolatunnus',
      placeholder: 'esim. 6736f9f5f9e2ab82f9150420',
      invalid: 'Wolt-ravintolatunnus on 24 merkkiä pitkä ja sisältää vain merkkejä 0–9 ja a–f.',
    },
    priority: {
      label: 'Palveluntarjoajien järjestys',
      options: {
        wolt_primary: 'Wolt ensisijainen, muut palveluntarjoajat varalla',
        wolt_only: 'Vain Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt vahvisti tämän ravintolan.',
    failed: 'Wolt ei voinut vahvistaa tätä ravintolaa.',
    wolt_reason: 'Wolt ilmoitti: {{reason}}',
    unavailable_now: 'Wolt ei voi toimittaa tästä ravintolasta juuri nyt ({{reason}}). Voit silti tallentaa sen.',
  },
  preview: {
    label: 'Palveluntarjoajien järjestys',
    none: 'ei mitään',
  },
  hints: {
    internal_delivery:
      'Tämä ravintola kuljettaa tilaukset omilla kuljettajillaan. Wolt otetaan käyttöön, kun Toimitustapa alla on asetettu ulkoisiin kuljettajiin.',
    invalid_stored_id:
      'Tallennettu ravintolatunnus {{venueId}} ei ole kelvollinen Wolt-ravintolatunnus, joten Woltia ei käytetä tälle ravintolalle. Vahvista ja tallenna oikea tunnus.',
  },
  buttons: {
    copy_details: 'Kopioi tiedot',
    verify: 'Vahvista',
    save: 'Tallenna',
  },
  confirm: {
    title: 'Aktivoidaanko Wolt Drive?',
    description:
      'Tallentaa ravintolatunnuksen {{venueId}} ja muuttaa palveluntarjoajajärjestyksen muotoon: {{providers}}.',
    unsaved_providers: 'Alla olevan palveluntarjoajaluettelon tallentamattomat muutokset korvataan.',
    ok: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    copied: 'Kopioitu',
    copy_failed: 'Tietojen kopiointi epäonnistui. Yritä uudelleen.',
    saved: 'Wolt Drive on asetettu tälle ravintolalle.',
    save_failed: 'Tallentaminen epäonnistui. Yritä uudelleen.',
  },
};
